import service from './request'
import store from '@/store'

// 获取国家
export const getCountry = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.normal_country,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

// 获取国家 更多
export const getCountryMore = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.CountryList,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

// 获取语言
export const getLanguage = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.normal_language,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

// 获取语言新
export const getLanguage_new = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.langList,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

// 获取任务列表
export const getTaskConfig = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.task_config,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

// 颜值标签列表
export const getFaceValueList = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.face_value,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

export const allChannelList = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.channelList,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

export const newChannelList = async () => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.newChannelList,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}

export const allRewardList = async (eventCode) => {
  let rs = null
  await service({
    type: 'GET',
    url: store.getters.path.rewardList,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode
    }
  }).then(res => {
    if (res.data.code === 0) {
      rs = res.data.data
    } else {
      alert(res.data.msg)
    }
  })
  return rs
}
